import Customer from "./Customer";
import { dashboardCustomers } from "../../endpoints";
import useFetch from "../../hooks/useFetch";

interface customerData {
  name: string;
  incidents: number;
  changes: number;
}

const DashboardCustomers = () => {
  const { data, loading } = useFetch<customerData>(dashboardCustomers);

  const completeData = data || [];

  return (
    <div className="mt-6 bg-white text-gray-600 rounded-xl shadow-md w-1/2 h-auto">
      {loading ? (
        <div className="m-3">
          <p className="text-3xl text-gray-400 mt-3 font-bold">
            Klanten laden...
          </p>
          <p className="text-gray-400">
            Een moment geduld, de gegevens worden geladen.
          </p>
        </div>
      ) : (
        <div className="flex flex-col items-center text-center w-full">
          <div className="w-full">
            <p className="text-2xl pt-3">Klanten</p>
            <div className="flex flex-row w-full text-center text-xl">
              <p className="mt-2 w-1/2">Klant</p>
              <div className="flex flex-row justify-evenly w-1/2">
                <p className="mt-2">Meldingen</p>
                <p className="mt-2">Wijzigingen</p>
              </div>
            </div>
          </div>
          <div className="w-full overflow-y-auto">
            {completeData.map((customer, index) => (
              <Customer
                key={index}
                name={customer.name}
                incidents={customer.incidents}
                changes={customer.changes}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardCustomers;
